export const environment = {
    apiUrl: 'https://api-dev.legitid.org/loyalty/api/',
    // apiUrl: 'http://localhost:6118/api/',
    oriURL: 'http://localhost:4200',
    pathURL: '/',
    contentRank: 'https://api-dev.legitid.org/content/loyalty/rank',
    contentReward: 'https://api-dev.legitid.org/content/loyalty/reward',
    contentCoupon: 'https://api-dev.legitid.org/content/loyalty/coupon',
    contentGift: 'https://api-dev.legitid.org/content/loyalty/gift',
    contentOG: 'https://api-dev.legitid.org/content/organizations/',
    replaceUrl: 'https://dashboard.legitid.org',
    apiPackage: 'https://api-dev.legitid.org/dashboard/api',
    keySystem: '2966ad39-1412-41f2-8616-b0555b1ae7f9'
};
